import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import { Modal, ModalBody } from "reactstrap";
import ChangeNickNameModal from "../../ManageDriver/SubComponents/NewDriverSideSection/SubComponents/ChangeNickNameModal";
import VehicleList from "../../ManageDriver/VehicleList";
import SvgImage from "../../Icons/Icons";
import AccountDetailsModal from "../../Modals/accountDetails";
import moment from "moment";

const DriverSalaryInfo=(props)=>{
    const [modal, setModal] = useState(false);
    const toggleInfo = () => setModal(!modal);
    const { salaryWalletDetails } = useSelector(
        state => state?.driverlist,
      );
      console.log('wallet idharrrrrrr', salaryWalletDetails);
    const {driverDetails, userId, cardType, driverFleet}= props;
    // const data1={
    //         nickname:"Raju",
    //         contact: 7602864000,
    //         exp:"58,0000.00", 
    //         veh:"WB27A 4748"
    //     }
    const dispatch= useDispatch();
    useEffect(()=>{
        console.log ("m2pppp");
        if(userId!=""){
            //dispatch(M2pUserDetailsAction(userId));
            //dispatch(m2pMonthlyBalanceAction(userId));
        }
        if(userId!=""&& cardType==1){
            //dispatch(getDriverBal(userId));
        }
    },[userId])

    const [open, setOpen] = useState(false);
    //const [proceed, setProceed] = useState(0);
    
    const toggleModal=()=>{
        setOpen(!open);
        // setProceed(0);
    }
    
    const handleClose = () => {
        setOpen(false);
        // setProceed(0);
    };
    
    const handleShow = () => {
        setOpen(true);
    };

    // for handling nickname modal 
    const [openName, setOpenName] = useState(false);
    //const [proceed, setProceed] = useState(0);
    
    const toggleModalName=()=>{
        setOpenName(!openName);
        // setProceed(0);
    }
    
    const handleCloseName = () => {
        setOpenName(false);
        // setProceed(0);
    };
    
    const handleShowName = () => {
        setOpenName(true);
    };    

    //const driverBal = useSelector((state) => state?.driverlist?.bal);
    //const m2pBal = useSelector((state) => state?.driverlist?.bal);
    //const m2pMonthlySpend=useSelector((state) => state?.m2p?.m2pMonthlyBal?.response?.thisMonthSpending);

    //console.log("driver test",cardType ,driverBal, m2pMonthlySpend )
    //const monthlyExp= cardType ==2?(m2pMonthlySpend== null?0: m2pMonthlySpend):driverBal.monthlySpend == null ? 0 : driverBal.monthlySpend;
    return(
      <>
        <div className="row whiteBackground boxShadowIntro" style={{margin:"0", borderRadius:"0.5rem"}}>
            <div className="col-8 padding8" style={{display:'flex', alignItems:'center', justifyContent:"space-between", width:'100%'}}> 
              <div className="flexStyling">
                <SvgImage name="driverPageIcon" />
                <div className="padding16L">
                    <div className="flexStyling">
                      <div className="Bold heading2">{salaryWalletDetails?.fullName==null?"Select Driver":salaryWalletDetails?.fullName}</div>
                      {/* <div className="greyFont Bold heading2 padding8L">
                        ({driverDetails?.nickname?driverDetails?.nickname:"NA"})
                      </div>
                      <div onClick={handleShowName} style={{cursor:"pointer"}}>
                        <SvgImage name="editLogo" width="23" height="23" />
                      </div> */}
                    </div>
                    <div className="Regular heading3">Contact: {salaryWalletDetails?.phone==null?"N/A":salaryWalletDetails.phone}</div>
                </div>
              </div>
              <div className="padding16L driverBankInfo">
              <SvgImage name='bankLogo' />
                <div className="padding8L padding8R">
                    <div className="semiBold heading4 greenFont">Bank Details</div>
                    {/* <div className={driverFleet == null?"Bold heading4":driverFleet == "Driver not selected"?"Bold heading4":"FontSmall"}>
                        Holder Name: {salaryWalletDetails?.fullName}
                    </div> */}
                    <div className={driverFleet == null?"Bold heading4":driverFleet == "Driver not selected"?"Bold heading4":"FontSmall"}>
                        A/C No: {salaryWalletDetails?.accountNo ? salaryWalletDetails?.accountNo : 'N/A' }
                    </div>
                    <div className={"FontSmall"} style={{color:'#ED752E', textDecorationLine:'underline', cursor:'pointer'}}
                    onClick={toggleInfo}
                    >
                        View Details
                    </div>
                    {/* <div className={driverFleet == null?"Bold heading4":driverFleet == "Driver not selected"?"Bold heading4":"FontSmall"}>
                        IFSC Code: {salaryWalletDetails?.ifsc}
                    </div> */}
                    
                </div>
              </div>
              {/* <div className="padding8L driverBankInfo" style={{paddingRight:"12px"}}>
                  <SvgImage name='Truck' />
                  <div style={{marginLeft:"11px"}}>
                    <div className="Regular heading3">Assigned Vehicle</div>
                    <div className="Bold heading3">{driverFleet}</div>
                </div>
              </div> */}
              
            </div>
            {/* <div className="col-4 padding8L padding16T driverCardColor flexStyling" 
              style={{ borderRadius:"0 0.5rem 0.5rem 0"}}
              // onClick={()=>{
              //         handleShow()
              // }}
            >
                <SvgImage name="driverPageIconSmall" />
                <div className="padding8L padding8R">
                    <div className="semiBold heading4 greenFont">Bank Details</div>
                    <div className={driverFleet == null?"Bold heading4":driverFleet == "Driver not selected"?"Bold heading4":"FontSmall"}>
                        Holder Name: {salaryWalletDetails?.fullName}
                    </div>
                    <div className={driverFleet == null?"Bold heading4":driverFleet == "Driver not selected"?"Bold heading4":"FontSmall"}>
                        A/C No: {salaryWalletDetails?.accountNo}
                    </div>
                    <div className={driverFleet == null?"Bold heading4":driverFleet == "Driver not selected"?"Bold heading4":"FontSmall"}>
                        IFSC Code: {salaryWalletDetails?.ifsc}
                    </div>
                    
                </div>
            </div> */}
            {
        <Modal
          isOpen={open}
          onHide={handleClose}
          className="PGCollection-modal"
          toggle={toggleModal}
          aria-labelledby="myModalLabel2"
        >
          {/* <Button
            type="button"
            className="close-btn"
            onClick={toggleModal}
            aria-label="Close"
          >
            <SvgImage name="CloseButtonLogo" />
          </Button> */}
          <ModalBody style={{paddingTop:"0"}}>
            <div className="PGCollectionBox">
            <div 
                className= /*"PGCollectionclose */ "row close-btn-for-transaction padding16T"
                onClick={toggleModal}>
                  <div className="col-10"></div>
                <div className="col-1"  style={{textAlign:"right" }}            >
                  <SvgImage
                    classname = 'close-btn-text'
                    style={{ width: "10%", height: "10%" }}
                    name="CloseButtonLogo"
                    width="20%"
                    height="20%"
                  />
                </div>
                <div className="col-1 padding0L" >Close</div>
              </div>
              <VehicleList setVehicleNumber={props.setVehicleNumber} driverID={props.driverID} handleClick={handleClose} toggleModal={toggleModal} />
            </div>
          </ModalBody>
        </Modal>
      }
        </div>

        <div className="row whiteBackground" style={{margin:"28px 0", borderRadius:"0.5rem"}}>
            <div className="col-8 padding8" style={{display:'flex', alignItems:'center', justifyContent:"space-between", width:'100%'}}> 
              <div className="flexStyling salaryInfo">
                <div className="rightVertical"></div>
                <span className="Bold heading3" style={{color:'#09BD7B', marginRight:'5px'}}>Working Days:</span>
                <span className="Medium heading3" >{salaryWalletDetails?.workingDays ? salaryWalletDetails?.workingDays : 'N/A'}</span> 
              </div>
              <div className="flexStyling salaryInfo2">
                <div className="rightVertical2"></div>
                <span className="Bold heading3" style={{color:'#000', marginRight:'5px'}}>Last Paid Date:</span>
                <span className="Medium heading3" > {salaryWalletDetails?.lastSalaryDate ? moment(salaryWalletDetails?.lastSalaryDate).format('DD/MM/YYYY'): 'N/A' }</span> 
              </div>
              <div className="flexStyling salaryInfo3">
                <div className="rightVertical3"></div>
                <span className="Bold heading3" style={{color:'#E63946', marginRight:'5px'}}>Early Salary Amount Taken: </span>
                <span className="Medium heading3" > ₹{salaryWalletDetails?.reImbursableAmount ? salaryWalletDetails?.reImbursableAmount : "N/A"}</span> 
              </div>         
            </div>
        </div>
        <AccountDetailsModal modal={modal} toggle={toggleInfo}/>
        <ChangeNickNameModal 
          open={openName}
          toggleModal={toggleModalName}
          handleClose={handleCloseName}
          driverName={driverDetails?.name}
          phone={driverDetails.phone}
          nickname={driverDetails?.nickname?driverDetails?.nickname:"NA"}
          />

        </>
    )
}

export default DriverSalaryInfo;